export const colors = {
  main: "#4A5C58",
  secondary: "#E0B6BC",
  accent: "#E07080",
  beige: "#F4F1ED",
  grey: "#929292",
}
